// extracted by mini-css-extract-plugin
module.exports = {"registryPageLayout":"RegistryPageLayout_registryPageLayout__LK6Db","login":"RegistryPageLayout_login__7ppsL"};